export default __webpack_public_path__ + "static/media/badgeIcon.bb634e53.svg";